// extracted by mini-css-extract-plugin
module.exports = {"screenshareHolder":"Screenshare_screenshareHolder__2CMDB"};